import React, { useRef, useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MenuComponent from "./MenuComponent";
import MenuItemComponent from "./MenuItemComponent";

/**
 * NestedMenuItem
 * A MenuItem that opens a submenu on hover.
 * Props: label, disabled, parentMenuOpen, children (submenu items), icon.
 */
function NestedMenuItem({ label, disabled = false, parentMenuOpen, children, icon, ...rest }: any) {
  const menuItemRef = useRef<HTMLLIElement>(null);
  const [open, setOpen] = useState(false);

  const handleMouseEnter = () => {
    if (!disabled) setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  const isOpen = open && parentMenuOpen;

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <MenuItemComponent ref={menuItemRef} disabled={disabled} sx={{ justifyContent: "space-between" }} {...rest}>
        <span style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          {icon && <span style={{ display: "flex", alignItems: "center", width: "1.25rem" }}>{icon}</span>}
          {label}
        </span>
        <ChevronRightIcon sx={{ fontSize: "1.125rem", color: "#8B8FA3", ms: 1 }} />
      </MenuItemComponent>
      <MenuComponent
        anchorEl={menuItemRef.current}
        open={isOpen}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        sx={{ pointerEvents: "none" }}
        paperSx={{ pointerEvents: "auto" }}
        disableAutoFocus
        disableEnforceFocus
        hideBackdrop
      >
        {children}
      </MenuComponent>
    </div>
  );
}

export default NestedMenuItem;
